import useGetUserViewsStats from './useGetUserViewsStats'

export default useGetUserViewsStats
